import { Box, Grid, Skeleton } from '@mui/material';
import Typography from '@mui/material/Typography';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { HrPage } from 'routes/HumanResourcesModule/components/ui/HrPage';
import { useGetAllRetrospective } from '../helpers/hooks/retrospective';
import AddRetrospectiveButton from './components/AddRetrospectiveButton';
import RetrospectiveItem from './RetrospectiveItem/RetrospectiveItem';
import Flex from 'ui/Flex/Flex';

const StyHeader = (props: { children: React.ReactNode }) => {
    return (
        <Flex alignItems="center" gap="2em">
            {props.children}
        </Flex>
    );
};

function LoadingPage(): React.ReactElement<[]> {
    const { t } = useTranslation();
    return (
        <HrPage title={t('header.retrospectives')}>
            <StyHeader>
                <Typography
                    display="inline"
                    sx={{
                        width: '40%',
                        fontSize: '16px',
                        fontWeight: 600,
                    }}
                >
                    <Skeleton />
                </Typography>
                <Skeleton
                    variant="rectangular"
                    sx={{
                        borderRadius: '20px',
                        height: '2em',
                        width: '5%',
                    }}
                />
            </StyHeader>
            <Box>
                <Grid container spacing={2}>
                    {[1, 2, 3, 4].map((item) => (
                        <Grid item xs={12} sm={6} md={4} key={item}>
                            <Skeleton
                                variant="rectangular"
                                sx={{
                                    borderRadius: '4px',
                                    height: '12rem',
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </HrPage>
    );
}

function RetrospectiveHome(): React.ReactElement<[]> {
    const { t } = useTranslation();

    const { data: retrospectivesData, isLoading: isRetrospectiveLoading } =
        useGetAllRetrospective();

    const retrospectives = retrospectivesData || [];

    if (isRetrospectiveLoading) {
        return <LoadingPage />;
    }

    return (
        <HrPage title={t('header.retrospectives')}>
            <StyHeader>
                <Typography
                    display="inline"
                    sx={{
                        fontSize: '16px',
                        fontWeight: 600,
                    }}
                >
                    {t('humanResources.selectRetrospective')}
                </Typography>
            </StyHeader>
            <Box>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4}>
                        <AddRetrospectiveButton />
                    </Grid>
                    {_(retrospectives)
                        .sortBy('id')
                        .reverse()
                        .value()
                        .map((item) => (
                            <Grid item xs={12} sm={6} md={4} key={item.id}>
                                <RetrospectiveItem retrospective={item} />
                            </Grid>
                        ))}
                </Grid>
            </Box>
        </HrPage>
    );
}

export default memo(RetrospectiveHome);
